// import Isotope from 'isotope-layout';
import Foundation from 'foundation-sites';
import Swiper from 'swiper';
import Chart from 'chart.js';
import $ from 'jquery';
//window.$ = $;

$(document).foundation();

$(document).ready(function ($) {
	// Initialize new Swiper on each .swiper-container
	// $('.swiper-container').each(function() {
	//   new Swiper(this, {
	//     pagination: {
	//       el: $(this).find('.swiper-pagination'),
	//       dynamicBullets: false
	//     },
	//     navigation: {
	//       nextEl: $(this).find('.swiper-button-next'),
	//       prevEl: $(this).find('.swiper-button-prev')
	//     },
	//     spaceBetween: 30,
	//     autoHeight: true,
	//     slidesPerView: 3,
	//     loop: false
	//   })
	// })
	var swiper = new Swiper('.swiper-container.quotes-swiper', {
		slidesPerView: 'auto',
		spaceBetween: 30,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});

	$(window).scroll(function () {
		$('.site-header').toggleClass('shrink', $(window).scrollTop() > 100);
	});

	// ANimated Menu item
	(function () {
		// On icon click...
		$('.menu-link-wrapper').on('click.mobileNav', function () {
			// Toggle the open/closed state of the menu icon
			$('.menu-link-wrapper .menu-link').toggleClass('menu-trigger-open');
		});
	})();
});

jQuery(function ($) {
	var $container = $('#isotope-list'); //The ID for the list with all the blog posts
	$container.imagesLoaded(function () {
		$container.isotope({
			//Isotope options, 'item' matches the class in the PHP
			itemSelector: '.item',
			layoutMode: 'masonry',
		});
	});

	//Add the class selected to the item that is clicked, and remove from the others
	var $optionSets = $('#filters'),
		$optionLinks = $optionSets.find('a');

	$optionLinks.click(function () {
		var $this = $(this);
		// don't proceed if already selected
		if ($this.hasClass('selected')) {
			return false;
		}
		var $optionSet = $this.parents('#filters');
		$optionSets.find('.selected').removeClass('selected');
		$this.addClass('selected');

		//When an item is clicked, sort the items.
		var selector = $(this).attr('data-filter');
		$container.isotope({ filter: selector });

		return false;
	});

	$('.js-anim-menu-btn').click(function () {
		$(this).toggleClass('anim-menu-btn--state-b');
	});
});

// Charts
Chart.defaults.global.defaultFontFamily = 'Montserrat-Bold';
Chart.defaults.global.defaultFontSize = 16;
Chart.defaults.global.defaultFontColor = 'black';

// Funds Chart
if (document.getElementById('fundsChart') != null) {
	var fundsctx = document.getElementById('fundsChart').getContext('2d');
	var fundsChart = new Chart(fundsctx, {
		type: 'doughnut',
		data: {
			labels: ['Spenden (aufwandswirksam)', 'Mitgliedsbeiträge', 'Projektförderung', 'Sonstiges'],
			datasets: [
				{
					label: '€',
					data: [13085169, 4008567, 3125639, 13661 + 369799],
					backgroundColor: ['#2eb276', '#56c595', '#8ad8b7', '#a5e1c9'],
					borderWidth: 0,
				},
			],
		},
		options: {
			responsive: true,
			//maintainAspectRatio: true,
			legend: {
				display: true,
				align: 'center',
			},
			// Source for Tooltip hack: https://stackoverflow.com/questions/49491046/chart-js-thousand-separator-currency-in-tool-tips-x-y-axes-labels
			tooltips: {
				callbacks: {
					// this callback is used to create the tooltip label
					label: function (tooltipItem, data) {
						// get the data label and data value to display
						// convert the data value to local string so it uses a comma seperated number
						var dataLabel = data.labels[tooltipItem.index];
						// add the currency symbol $ to the label
						var v =
							(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] /
								data.datasets[tooltipItem.datasetIndex].data.reduce((a, b) => {
									return a + b;
								})) *
							100;

						var value = ' : ' + v.toFixed(1).toLocaleString() + ' % ';
						// make sure this isn't a multi-line label (e.g. [["label 1 - line 1, "line 2, ], [etc...]])
						if (Chart.helpers.isArray(dataLabel)) {
							// show value on first line of multiline label
							// need to clone because we are changing the value
							dataLabel = dataLabel.slice();
							dataLabel[0] += value;
						} else {
							dataLabel += value;
						}
						// return the text to display on the tooltip
						return dataLabel;
					},
				},
				// Custom Tooltips
				// Disable the on-canvas tooltip
				enabled: false,

				custom: function (tooltipModel) {
					// Tooltip Element
					var tooltipEl = document.getElementById('chartjs-tooltip');

					// Create element on first render
					if (!tooltipEl) {
						tooltipEl = document.createElement('div');
						tooltipEl.id = 'chartjs-tooltip';
						tooltipEl.innerHTML = '<div class="chart-js-tooltip"></div>';
						document.body.appendChild(tooltipEl);
					}

					// Hide if no tooltip
					if (tooltipModel.opacity === 0) {
						tooltipEl.style.opacity = 0;
						return;
					}

					// Set caret Position
					tooltipEl.classList.remove('above', 'below', 'no-transform');
					if (tooltipModel.yAlign) {
						tooltipEl.classList.add(tooltipModel.yAlign);
					} else {
						tooltipEl.classList.add('no-transform');
					}

					function getBody(bodyItem) {
						return bodyItem.lines;
					}

					// Set Text
					if (tooltipModel.body) {
						var titleLines = tooltipModel.title || [];
						var bodyLines = tooltipModel.body.map(getBody);

						var innerHtml = '<div>';

						titleLines.forEach(function (title) {
							innerHtml += '<div>' + title + '</div>';
						});
						innerHtml += '</div><div>';

						bodyLines.forEach(function (body, i) {
							var colors = tooltipModel.labelColors[i];
							var style = 'background:' + colors.backgroundColor;
							style += '; border-color:' + colors.borderColor;
							style += '; border-width: 2px';
							var span = '<span style="' + style + '"></span>';
							innerHtml += '<span class="label">' + span + body + '</span>';
						});
						innerHtml += '</div>';

						var tableRoot = tooltipEl.querySelector('.chart-js-tooltip');
						tableRoot.innerHTML = innerHtml;
					}

					// `this` will be the overall tooltip
					var position = this._chart.canvas.getBoundingClientRect();

					// Display, position, and set styles for font
					tooltipEl.style.opacity = 1;
					tooltipEl.style.position = 'absolute';
					tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
					tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
					tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
					tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
					tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
					tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
					tooltipEl.style.pointerEvents = 'none';
				},
			},
		},
	});
}

if (document.getElementById('fundsChartEN') != null) {
	var fundsctx = document.getElementById('fundsChartEN').getContext('2d');
	var fundsChart = new Chart(fundsctx, {
		type: 'doughnut',
		data: {
			labels: ['Donations (cost-effective)', 'Membership fees', 'Project support', 'Other'],
			datasets: [
				{
					label: '€',
					data: [13085169, 4008567, 3125639, 13661 + 369799],
					backgroundColor: ['#2eb276', '#56c595', '#8ad8b7', '#a5e1c9'],
					borderWidth: 0,
				},
			],
		},
		options: {
			responsive: true,
			//maintainAspectRatio: true,
			legend: {
				display: true,
				align: 'center',
			},
			// Source for Tooltip hack: https://stackoverflow.com/questions/49491046/chart-js-thousand-separator-currency-in-tool-tips-x-y-axes-labels
			tooltips: {
				callbacks: {
					// this callback is used to create the tooltip label
					label: function (tooltipItem, data) {
						// get the data label and data value to display
						// convert the data value to local string so it uses a comma seperated number
						var dataLabel = data.labels[tooltipItem.index];
						// add the currency symbol $ to the label
						var v =
							(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] /
								data.datasets[tooltipItem.datasetIndex].data.reduce((a, b) => {
									return a + b;
								})) *
							100;

						var value = ' : ' + v.toFixed(1).toLocaleString() + ' % ';
						if (Chart.helpers.isArray(dataLabel)) {
							// show value on first line of multiline label
							// need to clone because we are changing the value
							dataLabel = dataLabel.slice();
							dataLabel[0] += value;
						} else {
							dataLabel += value;
						}
						// return the text to display on the tooltip
						return dataLabel;
					},
				},
				// Custom Tooltips
				// Disable the on-canvas tooltip
				enabled: false,

				custom: function (tooltipModel) {
					// Tooltip Element
					var tooltipEl = document.getElementById('chartjs-tooltip');

					// Create element on first render
					if (!tooltipEl) {
						tooltipEl = document.createElement('div');
						tooltipEl.id = 'chartjs-tooltip';
						tooltipEl.innerHTML = '<div class="chart-js-tooltip"></div>';
						document.body.appendChild(tooltipEl);
					}

					// Hide if no tooltip
					if (tooltipModel.opacity === 0) {
						tooltipEl.style.opacity = 0;
						return;
					}

					// Set caret Position
					tooltipEl.classList.remove('above', 'below', 'no-transform');
					if (tooltipModel.yAlign) {
						tooltipEl.classList.add(tooltipModel.yAlign);
					} else {
						tooltipEl.classList.add('no-transform');
					}

					function getBody(bodyItem) {
						return bodyItem.lines;
					}

					// Set Text
					if (tooltipModel.body) {
						var titleLines = tooltipModel.title || [];
						var bodyLines = tooltipModel.body.map(getBody);

						var innerHtml = '<div>';

						titleLines.forEach(function (title) {
							innerHtml += '<div>' + title + '</div>';
						});
						innerHtml += '</div><div>';

						bodyLines.forEach(function (body, i) {
							var colors = tooltipModel.labelColors[i];
							var style = 'background:' + colors.backgroundColor;
							style += '; border-color:' + colors.borderColor;
							style += '; border-width: 2px';
							var span = '<span style="' + style + '"></span>';
							innerHtml += '<span class="label">' + span + body + '</span>';
						});
						innerHtml += '</div>';

						var tableRoot = tooltipEl.querySelector('.chart-js-tooltip');
						tableRoot.innerHTML = innerHtml;
					}

					// `this` will be the overall tooltip
					var position = this._chart.canvas.getBoundingClientRect();

					// Display, position, and set styles for font
					tooltipEl.style.opacity = 1;
					tooltipEl.style.position = 'absolute';
					tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
					tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
					tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
					tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
					tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
					tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
					tooltipEl.style.pointerEvents = 'none';
				},
			},
		},
	});
}

// expenditure Chart
if (document.getElementById('expenditureChart') != null) {
	var expenditurectx = document.getElementById('expenditureChart').getContext('2d');
	var expenditureChart = new Chart(expenditurectx, {
		type: 'doughnut',
		data: {
			labels: [
				'Mittelweiterleitung WMF',
				'Handlungsfeld Freiwillige',
				'Handlungsfeld Technologie',
				'Handlungsfeld Rahmenbedingungen',
				'Öffentlichkeitsarbeit und Werbung',
				'Verwaltungskosten',
			],
			datasets: [
				{
					label: '€',
					data: [8672510, 2274162, 2662490, 2178644, 2373286, 2441743],
					backgroundColor: ['#2eb276', '#56c595', '#8ad8b7', '#a5e1c9', '#c2ebda', '#c2ebda66'],
					borderWidth: 0,
				},
			],
		},
		options: {
			responsive: true,
			maintainAspectRatio: true,
			legend: {
				display: true,
				align: 'center',
			},
			// Source for Tooltip hack: https://stackoverflow.com/questions/49491046/chart-js-thousand-separator-currency-in-tool-tips-x-y-axes-labels
			tooltips: {
				callbacks: {
					// this callback is used to create the tooltip label
					label: function (tooltipItem, data) {
						// get the data label and data value to display
						// convert the data value to local string so it uses a comma seperated number
						var dataLabel = data.labels[tooltipItem.index];
						// add the currency symbol $ to the label
						var v =
							(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] /
								data.datasets[tooltipItem.datasetIndex].data.reduce((a, b) => {
									return a + b;
								})) *
							100;

						var value = ' : ' + v.toFixed(1).toLocaleString() + ' % ';
						if (Chart.helpers.isArray(dataLabel)) {
							// show value on first line of multiline label
							// need to clone because we are changing the value
							dataLabel = dataLabel.slice();
							dataLabel[0] += value;
						} else {
							dataLabel += value;
						}
						// return the text to display on the tooltip
						return dataLabel;
					},
				},
				// Custom Tooltips
				// Disable the on-canvas tooltip
				enabled: false,

				custom: function (tooltipModel) {
					// Tooltip Element
					var tooltipEl = document.getElementById('chartjs-tooltip');

					// Create element on first render
					if (!tooltipEl) {
						tooltipEl = document.createElement('div');
						tooltipEl.id = 'chartjs-tooltip';
						tooltipEl.innerHTML = '<div class="chart-js-tooltip"></div>';
						document.body.appendChild(tooltipEl);
					}

					// Hide if no tooltip
					if (tooltipModel.opacity === 0) {
						tooltipEl.style.opacity = 0;
						return;
					}

					// Set caret Position
					tooltipEl.classList.remove('above', 'below', 'no-transform');
					if (tooltipModel.yAlign) {
						tooltipEl.classList.add(tooltipModel.yAlign);
					} else {
						tooltipEl.classList.add('no-transform');
					}

					function getBody(bodyItem) {
						return bodyItem.lines;
					}

					// Set Text
					if (tooltipModel.body) {
						var titleLines = tooltipModel.title || [];
						var bodyLines = tooltipModel.body.map(getBody);

						var innerHtml = '<div>';

						titleLines.forEach(function (title) {
							innerHtml += '<div>' + title + '</div>';
						});
						innerHtml += '</div><div>';

						bodyLines.forEach(function (body, i) {
							var colors = tooltipModel.labelColors[i];
							var style = 'background:' + colors.backgroundColor;
							style += '; border-color:' + colors.borderColor;
							style += '; border-width: 2px';
							var span = '<span style="' + style + '"></span>';
							innerHtml += '<span class="label">' + span + body + '</span>';
						});
						innerHtml += '</div>';

						var tableRoot = tooltipEl.querySelector('.chart-js-tooltip');
						tableRoot.innerHTML = innerHtml;
					}

					// `this` will be the overall tooltip
					var position = this._chart.canvas.getBoundingClientRect();

					// Display, position, and set styles for font
					tooltipEl.style.opacity = 1;
					tooltipEl.style.position = 'absolute';
					tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
					tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
					tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
					tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
					tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
					tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
					tooltipEl.style.pointerEvents = 'none';
				},
			},
		},
	});
}

if (document.getElementById('expenditureChartEN') != null) {
	var expenditurectx = document.getElementById('expenditureChartEN').getContext('2d');
	var expenditureChart = new Chart(expenditurectx, {
		type: 'doughnut',
		data: {
			labels: [
				'Distribution of funds WMF',
				'Field of action volunteers',
				'Field of action technology',
				'Field of action conditions',
				'Public relations and advertising',
				'Administrative costs',
			],
			datasets: [
				{
					label: '€',
					data: [8672510, 2274162, 2662490, 2178644, 2373286, 2441743],
					backgroundColor: ['#2eb276', '#56c595', '#8ad8b7', '#a5e1c9', '#c2ebda', '#c2ebda66'],
					borderWidth: 0,
				},
			],
		},
		options: {
			responsive: true,
			maintainAspectRatio: true,
			legend: {
				display: true,
				align: 'center',
			},
			// Source for Tooltip hack: https://stackoverflow.com/questions/49491046/chart-js-thousand-separator-currency-in-tool-tips-x-y-axes-labels
			tooltips: {
				callbacks: {
					// this callback is used to create the tooltip label
					label: function (tooltipItem, data) {
						// get the data label and data value to display
						// convert the data value to local string so it uses a comma seperated number
						var dataLabel = data.labels[tooltipItem.index];
						// add the currency symbol $ to the label
						var v =
							(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] /
								data.datasets[tooltipItem.datasetIndex].data.reduce((a, b) => {
									return a + b;
								})) *
							100;

						var value = ' : ' + v.toFixed(1).toLocaleString() + ' % ';
						if (Chart.helpers.isArray(dataLabel)) {
							// show value on first line of multiline label
							// need to clone because we are changing the value
							dataLabel = dataLabel.slice();
							dataLabel[0] += value;
						} else {
							dataLabel += value;
						}
						// return the text to display on the tooltip
						return dataLabel;
					},
				},
				// Custom Tooltips
				// Disable the on-canvas tooltip
				enabled: false,

				custom: function (tooltipModel) {
					// Tooltip Element
					var tooltipEl = document.getElementById('chartjs-tooltip');

					// Create element on first render
					if (!tooltipEl) {
						tooltipEl = document.createElement('div');
						tooltipEl.id = 'chartjs-tooltip';
						tooltipEl.innerHTML = '<div class="chart-js-tooltip"></div>';
						document.body.appendChild(tooltipEl);
					}

					// Hide if no tooltip
					if (tooltipModel.opacity === 0) {
						tooltipEl.style.opacity = 0;
						return;
					}

					// Set caret Position
					tooltipEl.classList.remove('above', 'below', 'no-transform');
					if (tooltipModel.yAlign) {
						tooltipEl.classList.add(tooltipModel.yAlign);
					} else {
						tooltipEl.classList.add('no-transform');
					}

					function getBody(bodyItem) {
						return bodyItem.lines;
					}

					// Set Text
					if (tooltipModel.body) {
						var titleLines = tooltipModel.title || [];
						var bodyLines = tooltipModel.body.map(getBody);

						var innerHtml = '<div>';

						titleLines.forEach(function (title) {
							innerHtml += '<div>' + title + '</div>';
						});
						innerHtml += '</div><div>';

						bodyLines.forEach(function (body, i) {
							var colors = tooltipModel.labelColors[i];
							var style = 'background:' + colors.backgroundColor;
							style += '; border-color:' + colors.borderColor;
							style += '; border-width: 2px';
							var span = '<span style="' + style + '"></span>';
							innerHtml += '<span class="label">' + span + body + '</span>';
						});
						innerHtml += '</div>';

						var tableRoot = tooltipEl.querySelector('.chart-js-tooltip');
						tableRoot.innerHTML = innerHtml;
					}

					// `this` will be the overall tooltip
					var position = this._chart.canvas.getBoundingClientRect();

					// Display, position, and set styles for font
					tooltipEl.style.opacity = 1;
					tooltipEl.style.position = 'absolute';
					tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
					tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
					tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
					tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
					tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
					tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
					tooltipEl.style.pointerEvents = 'none';
				},
			},
		},
	});
}

// Member Chart
if (document.getElementById('membersChart') != null) {
	var memberctx = document.getElementById('membersChart').getContext('2d');
	var myChart = new Chart(memberctx, {
		type: 'horizontalBar',
		responsive: true,
		maintainAspectRatio: true,
		data: {
			labels: [
				'März 2021: 89.182',
				'März 2020: 79.278',
				'März 2019: 72.611',
				'März 2018: 65.374',
				'März 2017: 43.138',
				'März 2016: 29.169',
				'März 2015: 15.778',
				'März 2014: 9.803',
				'März 2013: 2.618',
			],
			datasets: [
				{
					label: '#',
					data: [89182, 79278, 72611, 65374, 43138, 29169, 15778, 9803, 2618],
					backgroundColor: [
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
					],
					borderWidth: 0,
				},
			],
		},
		options: {
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						gridLines: {
							display: false,
						},
					},
				],
				yAxes: [
					{
						gridLines: {
							display: false,
						},
					},
				],
			},
			tooltips: {
				enabled: false,
			},
		},
	});
}

if (document.getElementById('membersChartEN') != null) {
	var memberctx = document.getElementById('membersChartEN').getContext('2d');
	var myChart = new Chart(memberctx, {
		type: 'horizontalBar',
		responsive: true,
		maintainAspectRatio: true,
		data: {
			labels: [
				'March 2021: 89.182',
				'March 2020: 79.278',
				'March 2019: 72.611',
				'March 2018: 65.374',
				'March 2017: 43.138',
				'March 2016: 29.169',
				'March 2015: 15.778',
				'March 2014: 9.803',
				'March 2013: 2.618',
			],
			datasets: [
				{
					label: '#',
					data: [89182, 79278, 72611, 65374, 43138, 29169, 15778, 9803, 2618],
					backgroundColor: [
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
						'#ffee52',
					],
					borderWidth: 0,
				},
			],
		},
		options: {
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						gridLines: {
							display: false,
						},
					},
				],
				yAxes: [
					{
						gridLines: {
							display: false,
						},
					},
				],
			},
			tooltips: {
				enabled: false,
			},
		},
	});
}
